export default {
  shokzRateQuery: {
    rateTypes: {
      fcl: 'FCL',
      lcl: 'LCL',
      air: 'Air',
      prePort: 'Pre Port',
      lastMile: 'Last Mile'
    },
    fields: {
      priceNo: 'Rate No.',
      validDate: 'Validity',
      supplierIds: 'Supplier',
      carrierIds: 'Carrier',
      airCarrierIds: 'Airline',
      cargoTypes: 'Cargo Type',
      onePrice: 'ALL IN Price',
      combinationType: 'Combination Type',
      originCountryId: 'Origin Country',
      destinationCountryId: 'Destination Country',
      routeIds: 'Discharge Route',
      directFlag: 'Direct/Transit',
      transitPortIds: 'Transit Port',
      transitAirportIds: 'Transit Airport',
      polId: 'POL',
      podId: 'Port of Discharge (POD)',
      departureAirportId: 'Departure Airport',
      arrivalAirportId: 'Arrival Airport',
      wharfIds: 'Terminal',
      segmentTransportMode: 'Transport Mode',
      loadingPortId: 'Loading Port',
      loadingStationId: 'Loading Station',
      addressType: 'Address Type',
      warehouseId: 'Warehouse',
      originNodeCountryId: 'Origin Country',
      originNodeSeaportId: 'Origin Port',
      originNodeTerminalId: 'Origin Terminal',
      originNodeAirportId: 'Origin Airport',
      unloadingCountryId: 'Discharge Country',
      unloadingSeaportId: 'Discharge Port',
      unloadingTerminalId: 'Discharge Terminal',
      unloadingAirportId: 'Discharge Airport',
      destinationId: 'Destination',
      serviceType: 'Service Type',
      level1Id: 'Country/Region',
      level2Id: 'State/Province',
      level3Id: 'City',
      level4Id: 'District/County',
      level5Id: 'Township/Street',
      level6Id: 'Community',
      detailAddress: 'Detailed Address',
      postalCode: 'Postal Code'
    },
    placeholders: {
      priceNo: 'Enter rate no.',
      id: 'Enter ID',
      idList: 'Enter IDs and press Enter',
      supplierIds: 'Select supplier',
      carrierIds: 'Select carrier',
      airCarrierIds: 'Select airline',
      cargoTypes: 'Select cargo type',
      select: 'Select',
      originCountryId: 'Select origin country',
      destinationCountryId: 'Select destination country',
      routeIds: 'Select discharge route',
      transitLocationIds: 'Select transit location',
      polId: 'Select POL',
      podId: 'Select Port of Discharge (POD)',
      departureAirportId: 'Select departure airport',
      arrivalAirportId: 'Select arrival airport',
      wharfIds: 'Select terminal',
      loadingPortId: 'Select loading port',
      loadingStationId: 'Select loading station',
      warehouseId: 'Select warehouse',
      nodeCountryId: 'Select country',
      nodeSeaportId: 'Select seaport',
      nodeTerminalId: 'Select terminal',
      nodeAirportId: 'Select airport',
      destinationId: 'Select destination',
      serviceType: 'Enter service type',
      level1Id: 'Select country/region',
      level2Id: 'Select state/province',
      level3Id: 'Select city',
      level4Id: 'Select district/county',
      level5Id: 'Select township/street',
      level6Id: 'Select community',
      detailAddress: 'Enter detailed address',
      postalCode: 'Enter postal code'
    },
    columns: {
      rateNo: 'Rate No.',
      rateType: 'Type',
      source: 'Source',
      supplierId: 'Supplier',
      carrierId: 'Carrier',
      originId: 'Origin',
      destinationId: 'Destination',
      prePortOrigin: 'Port / Airport of Loading',
      loadingLocation: 'Loading Location',
      lastMileOrigin: 'Discharge Port / Airport',
      deliveryLocation: 'Destination',
      placeOfDeliveryId: 'Place of Receipt',
      loadingPortId: 'Port of Loading',
      dischargePortId: 'Port of Discharge',
      destinationPortId: 'Place of Delivery (PDL)',
      terminalId: 'Terminal',
      laneCode: 'Lane Code',
      priceSummary: 'Price',
      airMinimum: 'M (Minimum)',
      status: 'Status',
      validDate: 'Validity',
      operations: 'Actions'
    },
    result: {
      total: '{total} rates',
      listView: 'List View',
      cardView: 'Card View'
    },
    card: {
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      originPort: 'POL',
      destinationPort: 'Port of Discharge (POD)',
      mainTransport: 'Main Leg',
      transportSegment: 'Transport Segment',
      perShipment: '/shipment',
      perKg: '/KG',
      noRemarks: 'No remarks'
    },
    combination: {
      priceFields: {
        unitRate: 'Unit Price',
        minCharge: 'Minimum Charge',
        maxCharge: 'Maximum Charge'
      },
      loadingCountry: 'Origin Country',
      loadingCountryPlaceholder: 'Select origin country',
      deliveryCountry: 'Destination Country',
      deliveryCountryPlaceholder: 'Select destination country',
      warehouseLoadFailed: 'Failed to load warehouses. Please try again.',
      destinationPort: 'Destination Port',
      destinationPortPlaceholder: 'Select destination port',
      onePrice: 'ALL IN Price',
      precise: 'Precise combination',
      free: 'Free combination'
    },
    actions: {
      search: 'Search',
      reset: 'Reset',
      combinationQuery: 'Combination Query',
      detail: 'Detail',
      schedule: 'Schedule',
      linkConsignment: 'Link Order'
    },
    detail: {
      title: 'Rate Detail',
      rawData: 'Warehouse Raw Detail'
    },
    schedule: {
      title: 'Schedule',
      noMatched: 'No real-time schedule matched. Showing schedule information maintained on the rate.',
      columns: {
        vessel: 'Vessel',
        voyage: 'Voyage',
        laneCode: 'Lane Code',
        etd: 'ETD',
        eta: 'ETA',
        transitDays: 'Transit Time',
        routeEtd: 'Sailing Day',
        cyClose: 'CY Close',
        cutOff: 'Customs Cutoff'
      }
    },
    enums: {
      yesNo: {
        yes: 'Yes',
        no: 'No'
      },
      directFlag: {
        direct: 'Direct',
        transit: 'Transit'
      },
      segmentTransportMode: {
        truck: 'Truck',
        barge: 'Barge',
        rail: 'Rail'
      },
      addressType: {
        thirdParty: 'Third-party Address',
        warehouse: 'Warehouse'
      },
      source: {
        inquiry: 'Inquiry',
        bidding: 'Bidding',
        manual: 'Manual',
        system: 'System'
      },
      status: {
        normal: 'Normal',
        expired: 'Expired',
        disabled: 'Disabled'
      }
    },
    messages: {
      queryFailed: 'Failed to query rates',
      detailFailed: 'Failed to load rate detail',
      scheduleUnsupported: 'Schedule matching is not supported for this rate type',
      scheduleMissingCondition: 'Carrier, POL or POD is missing, unable to match schedules',
      scheduleFailed: 'Failed to match schedules',
      linkTodo: 'Consignment linking will be connected in the next phase'
    }
  }
}
